import type { ConfigurationSetup } from './config/config-setup.types';
import { TeoEventTarget } from './utility/TeoEventTarget';

export interface DynamicConfigOptions {
  textConfigOptions: ConfigurationSetup | null;
  useExpParser: boolean;
  brandFitEnabled: boolean;
  textGeneratorEnabled: boolean;
}

export type DynamicConfigEvents = {
  [K in keyof DynamicConfigOptions]: (value: DynamicConfigOptions[K]) => void;
};

export class DynamicConfig extends TeoEventTarget<DynamicConfigEvents> {
  public readonly options: DynamicConfigOptions;

  constructor(options: Partial<DynamicConfigOptions> = {}) {
    super();
    this.options = {
      brandFitEnabled: false,
      useExpParser: false,
      textConfigOptions: null,
      textGeneratorEnabled: __DEV__,
      ...options,
    };
  }

  public update<K extends keyof DynamicConfigOptions>(
    property: K,
    value: DynamicConfigOptions[K],
    skipCheck: boolean = false,
  ): void {
    if (skipCheck || this.options[property] !== value) {
      this.options[property] = value;
      this.triggerEvent(property, value);
    }
  }
}
